import { createContext, useEffect, useState } from 'react'
import DICTIONARY from '../components/dictionary.js'
import { getBlob } from '../database/indexedDB.js'

export const SettingsContext = createContext()

export function SettingsProvider({ children }) {
  const storageData = localStorage.getItem('storageData')
    ? JSON.parse(localStorage.getItem('storageData'))
    : {}

  // console.log({ storageData })

  //  Play Lists
  const [checkAllPhrases, setcheckAllPhrases] = useState(
    Boolean(storageData.checkAllPhrases) ||
      //  if BOTH checkFavorites and checkSearch are unchecked,
      //  then checkAllPhrases should be checked.
      !(Boolean(storageData.checkFavorites) || Boolean(storageData.checkSearch))
  )
  const [checkFavorites, setCheckFavorites] = useState(
    Boolean(storageData.checkFavorites)
  )
  const [checkSearch, setCheckSearch] = useState(
    Boolean(storageData.checkSearch)
  )
  //  Play Mode
  const [checkAutoPlay, setCheckAutoPlay] = useState(
    Boolean(storageData.checkAutoPlay)
  )
  const [checkRandom, setCheckRandom] = useState(
    Boolean(storageData.checkRandom)
  )
  const [checkRepeat, setCheckRepeat] = useState(
    Boolean(storageData.checkRepeat)
  )
  //  Delay Text
  const [delayEng, setDelayEng] = useState(Boolean(storageData.delayEng))
  const [delayPhon, setDelayPhon] = useState(Boolean(storageData.delayPhon))
  const [delayChin, setDelayChin] = useState(Boolean(storageData.delayChin))
  const initialDelay = storageData.delayTime || 30
  const [delayTime, setDelayTime] = useState(initialDelay)
  //  Presets - these don't need to be reset from storageData
  const [listening, setListening] = useState(false)
  const [speaking, setSpeaking] = useState(false)
  const [reading, setReading] = useState(false)
  //  What tab is being displayed
  const [tabName, setTabName] = useState('settings')
  const [settingsDisplay, setSettingsDisplay] = useState('search')
  const [fadeInTimeOut, setfadeInTimeOut] = useState(null)

  const phraseId = storageData.currentPhraseId || {
    all: 1,
    favorites: 1,
    search: 1,
  }

  const [currentBlobs, setCurrentBlobs] = useState(null)
  const [currentPhraseId, setCurrentPhraseId] = useState(phraseId)

  function resetAll() {
    //  Play List   -                 I decided not to change the list
    // setcheckAllPhrases(true) setCheckFavorites(false) setCheckSearch(false)  Play
    // Mode
    setCheckAutoPlay(false)
    setCheckRandom(false)
    setCheckRepeat(false)
    setDelayTime(initialDelay)
    //  Delay Text
    setDelayEng(false)
    setDelayPhon(false)
    setDelayChin(false)
    //  Presets
    setListening(false)
    setSpeaking(false)
    setReading(false)
  }

  function listeningPreset() {
    //  Delay Text
    setDelayEng(true)
    setDelayPhon(false)
    setDelayChin(false)
    setCheckAutoPlay(true)
  }

  function speakingPreset() {
    //  Delay Text
    setDelayEng(false)
    setDelayPhon(true)
    setDelayChin(false)
    setCheckAutoPlay(false)
  }

  function readingPreset() {
    //  Delay Text
    setDelayEng(true)
    setDelayPhon(true)
    setDelayChin(false)
    setCheckAutoPlay(false)
  }

  function handleAddFadeIn(classArray) {
    //  The possible array elements are: ['english', 'phonetic', 'chinese']
    const divs = {}
    ;['english', 'phonetic', 'chinese'].forEach(line => {
      const div = document.querySelector(`.${line}`)
      divs[line] = div
      if (div) {
        div.classList.remove('showTextBackground')
        div.classList.remove('fadeIn')
        //  Returns a boolean as to wheather the text is dalayed or not
        const delayed =
          line === 'english'
            ? delayEng
            : line === 'phonetic'
            ? delayPhon
            : delayChin

        if (delayed) {
          div.classList.add('showTextBackground')
          div.classList.remove('fadeIn')
          //  Add 'fadeIn' to the lines that are not delayed
        } else {
          div.classList.add('fadeIn')
          div.classList.remove('showTextBackground')
        }

        //  Always add 'fadeIn' when clicked
        div.onclick = () => {
          div.classList.add('fadeIn')
          div.classList.remove('showTextBackground')
        }
      }
    })
    clearTimeout(fadeInTimeOut)
    if (startAutoplay) {
      //  If autoplay, then autoplay handles the fadeIn times
      setfadeInTimeOut(null)
    } else {
      //  Otherwise, setTimeout is needed -
      //  This adds fadeIn to all 3 lines - easier to cover it that way.
      setfadeInTimeOut(
        setTimeout(
          () => {
            ;['english', 'phonetic', 'chinese'].forEach(line => {
              divs[line]?.classList.add('fadeIn')
              divs[line]?.classList.remove('showTextBackground')
            })
          },
          Boolean(delayEng || delayPhon || delayChin) ? delayTime * 1000 : 0
        )
      )
    }
  }

  function handleDisEverything(action) {
    if (action === 'remove') {
      document.getElementById('main').classList.remove('disableEverything')
      document
        .getElementsByClassName('button-container')[0]
        .classList.remove('disableEverything')
    } else {
      document.getElementById('main').classList.add('disableEverything')
      document
        .getElementsByClassName('button-container')[0]
        .classList.add('disableEverything')
    }
  }

  //  Get the definitions
  function getCharInfo(char) {
    const def = DICTIONARY.find(eachDef => {
      if (eachDef.character) return eachDef.character.match(char)
      return false
    })
    return def
  }

  const [currentList, setCurrentList] = useState(storageData.currentList || [])
  const [currentIndex, setCurrentIndex] = useState(
    storageData.currentIndex || null
  )
  const [currentClip, setCurrentClip] = useState(
    storageData.currentClip || null
  )

  const [indexInfo, setIndexInfo] = useState(storageData.indexInfo || [])

  const [searchTerm, setSearchTerm] = useState(storageData.searchTerm || '')

  const [currentListName, setCurrentListName] = useState(
    storageData.currentListName || 'all'
  )
  // console.log(storageData.currentListName)

  const [startAutoplay, setStartAutoplay] = useState(null) //  start playing each clip auotomatically.

  //  setAudioEl is never used, just the src value is changed.
  const [audioEl, setAudioEl] = useState(new Audio())

  const [isPlaying, setIsPlaying] = useState(false)

  async function changeIndex(newIndex) {
    // console.log(newIndex)
    newIndex =
      newIndex < 0
        ? currentList.length - 1
        : newIndex > currentList.length - 1
        ? 0
        : newIndex
    // console.log(newIndex)

    // console.log(currentList[newIndex].chin)

    await getBlob({
      chinese: currentList[newIndex].chin,
      setCurrentBlobs: setCurrentBlobs,
    })

    console.log(currentBlobs)
    setCurrentIndex(newIndex)
    setCurrentClip(currentList[newIndex])
    setIndexInfo({ index: newIndex + 1, length: currentList.length })
    if (currentList[newIndex]?.chin && !checkRandom)
      setCurrentPhraseId(prev => {
        const newObj = prev
        const newId = currentList[newIndex]?.phraseId
        newObj[currentListName] = newId
        return newObj
      })
  }

  function shuffle(array) {
    let currentIndex = array.length

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      let randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--

      // And swap it with the current element.;
      ;[array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ]
    }

    return array
  }

  useEffect(() => {
    //    storageData is already there

    //      Lists
    storageData.checkAllPhrases = checkAllPhrases
    storageData.checkFavorites = checkFavorites
    storageData.checkSearch = checkSearch
    storageData.searchTerm = searchTerm
    //      Play mode
    storageData.checkAutoPlay = checkAutoPlay
    storageData.checkRandom = checkRandom
    storageData.checkRepeat = checkRepeat //  not currently used
    //      Delay values
    storageData.delayEng = delayEng
    storageData.delayPhon = delayPhon
    storageData.delayChin = delayChin
    storageData.delayTime = delayTime

    //     Phrase controls
    storageData.currentPhraseId = currentPhraseId
    storageData.currentList = currentList
    storageData.currentIndex = currentIndex
    storageData.currentClip = currentClip
    storageData.currentListName = currentListName
    storageData.indexInfo = indexInfo

    localStorage.setItem('storageData', JSON.stringify(storageData))
  }, [
    checkAllPhrases,
    checkFavorites,
    checkSearch,
    checkAutoPlay,
    checkRandom,
    checkRepeat,
    delayEng,
    delayPhon,
    delayChin,
    delayTime,
    currentPhraseId,
    currentList,
    currentIndex,
    currentClip,
    currentListName,
    indexInfo,
    searchTerm
  ])

  return (
    <SettingsContext.Provider
      value={{
        checkAllPhrases,
        setcheckAllPhrases,
        checkRandom,
        setCheckRandom,
        checkAutoPlay,
        setCheckAutoPlay,
        checkFavorites,
        setCheckFavorites,
        checkSearch,
        setCheckSearch,
        checkRepeat,
        setCheckRepeat,
        delayEng,
        setDelayEng,
        delayPhon,
        setDelayPhon,
        delayChin,
        setDelayChin,
        delayTime,
        setDelayTime,
        listening,
        setListening,
        speaking,
        setSpeaking,
        reading,
        setReading,
        resetAll,
        listeningPreset,
        speakingPreset,
        readingPreset,
        tabName,
        setTabName,
        settingsDisplay,
        setSettingsDisplay,
        handleAddFadeIn,
        getCharInfo,
        currentBlobs,
        setCurrentBlobs,
        currentPhraseId,
        setCurrentPhraseId,
        currentList,
        setCurrentList,
        currentIndex,
        setCurrentIndex,
        currentClip,
        setCurrentClip,
        changeIndex,
        currentListName,
        setCurrentListName,
        setIndexInfo,
        indexInfo,
        startAutoplay,
        setStartAutoplay,
        audioEl,
        isPlaying,
        setIsPlaying,
        handleDisEverything,
        shuffle,
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}
